/**
 * @method checkIsMobileApp
 */
const checkIsMobileApp = (searchQueryString) => {
  const searchParams = new URLSearchParams(searchQueryString);
  return (
    searchParams.has('mobileApp') || searchParams.has('mobileAppWithNewSync')
  );
};

export default checkIsMobileApp;
